import { GET_AVAILABLE_REQUESTS } from "../../../../enums/MyDivision/Delegation/RequestsDelegation.types";

export const getAvailableRequestsAction = (data) => {
    return {
        type: GET_AVAILABLE_REQUESTS,
        payload: data,
    }
}
